// extracted by mini-css-extract-plugin
export default {"animatedBox":"SingleTable_animatedBox__Zf-ia","fadeIn":"SingleTable_fadeIn__dgoDN","lightText":"SingleTable_lightText__6hZjo","slideUpFade":"SingleTable_slideUpFade__TDNyu"};